import Repository from './repository'

const resource = '/setorvenda'

export default {

  getId (id) {
    return Repository.get(`${resource}/${id}`)
  },
  getList (cdLoja) {
    return Repository.get(`${resource}/${cdLoja}`)
  },
  Update (data) {
    return Repository.post(`${resource}/editar/`, data)
  },
  Delete (data) {
    return Repository.post(`${resource}/excluir/`, data)
  },
  Save (data) {
    return Repository.post(`${resource}/save/`, data)
  },
}
